module.exports = __webpack_public_path__ + "img/login-theme2.ebe95a98.svg";